import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { markAllNotificationsAsRead } from '~/monolith-api';
import { getRecentNotificationsKey } from './useRecentNotifications';

export function useMarkAllNotificationsAsRead(options: UseMutationOptions<null, any, void> = {}) {
   const queryClient = useQueryClient();
   return useMutation<null, any, void>(
      async () => {
         return await markAllNotificationsAsRead();
      },
      {
         onSuccess() {
            queryClient.invalidateQueries(getRecentNotificationsKey());
         },
         ...options,
      }
   );
}
